<script>
	module.exports = {
		modelData: ['classCode']
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';
	@import 'mixins/layout';

	.student-instructions {
		&-steps {
			> li {
				margin-bottom: 3.5em;
				text-align: center;
				figure {
					position: relative;
					border: 1px solid $c-grey;
					img {
						display: block;
					}
					figcaption {
						position: absolute;
						left: 50%;
						top: -0.75em;
						transform: translateX(-50%);
						font-size: 1.75em;
						font-weight: 600;
						color: $c-white;
						background-color: $c-slate-dark;
						width: 1.75em;
						height: 1.75em;
						line-height: 1.75em;
						text-align: center;
						border-radius: 50%;
					}
				}
			}
			@media only screen and (min-width: $bp-width-med) {
				> li {
					@include span-columns(4);
					text-align: left;
					figure figcaption {
						left: -0.75em;
						transform: translateX(0);
					}
					p {
						font-size: 1.125em;
						line-height: 1.25em;
						.class-code {
							font-size: 2em;
							line-height: 1.25em;
							font-weight: 400;
						}
					}
				}
			}
		}
	}
</style>
<template>
	<div>
		<header class="main-header">
			<div class="wrapper">
				<a
					:href="`#!classAdmin:roster/classCode:${classCode}`"
					class="main-header-back"
					>&larr; Back to Class</a
				>
				<br />
				<h1 class="main-header-title">Invite Students</h1>
			</div>
		</header>
		<div class="main-content wrapper">
			<div class="student-instructions">
				<!--<p>Instruct students to sign up to access their assignments</p>-->
				<!--<h2>Student Instructions</h2>-->
				<ol class="student-instructions-steps list-unstyled">
					<li>
						<!--<figure>-->
						<!--<img src="http://placehold.it/640x640" alt="FPO Image">-->
						<!--<figcaption><span class="hidden-visually">Step</span> 1</figcaption>-->
						<!--</figure>-->
						<p style="font-weight: bold">Step 1: Have students go to</p>
						<p>
							<a
								href="/student"
								target="_blank"
								>www.readworks.org/student</a
							>
						</p>
						<p>Students should sign in with their Google account.</p>
					</li>
					<li>
						<!--<figure>-->
						<!--<img src="http://placehold.it/640x640" alt="FPO Image">-->
						<!--<figcaption><span class="hidden-visually">Step</span> 2</figcaption>-->
						<!--</figure>-->
						<p style="font-weight: bold">Step 2: Students enter the Class Code.</p>
						<p>
							The class code is <strong>{{ classCode }}</strong>
						</p>
					</li>
					<li>
						<!--<figure>-->
						<!--<img src="http://placehold.it/640x640" alt="FPO Image">-->
						<!--<figcaption><span class="hidden-visually">Step</span> 3</figcaption>-->
						<!--</figure>-->
						<p style="font-weight: bold">Step 3: Start assignments!</p>
						<p>Once students are part of your class, they will be able to access their assignments.</p>
					</li>
				</ol>
			</div>
		</div>
	</div>
</template>
